const TokenKey = 'Edu-Web-Admin-Token'

const ExpiresInKey = 'Edu-Web-Admin-Expires-In'

const Codes = 'Edu-Web-Admin-Codes'

export function getToken() {
  var token = localStorage.getItem(TokenKey);
  if (token) {
    return localStorage.getItem(TokenKey);
  }else{
      token = getQueryVariable("token");
    if(token){
      localStorage.setItem(TokenKey, token);
    }
    return token;
  }
  // return sessionStorage.getItem(TokenKey)
}

export function setToken(token) {
  return localStorage.setItem(TokenKey, token)
}

export function removeToken() {
  return localStorage.removeItem(TokenKey)
}

export function getExpiresIn() {
  return localStorage.getItem(ExpiresInKey) || -1
}

export function setExpiresIn(time) {
  return localStorage.setItem(ExpiresInKey, time)
}

export function removeExpiresIn() {
  return localStorage.removeItem(ExpiresInKey)
}

export function getCodeList() {
  return localStorage.getItem(Codes)
}

export function setCodeList(code) {
  return localStorage.setItem(Codes, code)
}
function getQueryVariable(variable)
{
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i=0;i<vars.length;i++) {
    var pair = vars[i].split("=");
    if(pair[0] == variable){return pair[1];}
  }
  return null;
}
